import { createRouter, createWebHistory } from 'vue-router'
import taxesRouters from './taxes'

export const routes = [
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    redirect: '/taxes/:tid',
    children: taxesRouters
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/components/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/notice/client'),
  routes: routes,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

router.beforeEach((to) => {
  document.title = to.name
})

export default router
